import * as React from 'react';

import { isTouchDevice } from '@repo/detection';
import { withEventScope } from '@repo/event-processor';
import { themeStyle } from '@repo/ui/theming';

import {
  Point,
  ScalingControlProps,
} from 'components/BackgroundReplacer/SourceTemplate/SimpleEditor/types';
import { usePointerEvents } from 'components/BackgroundReplacer/SourceTemplate/SimpleEditor/usePointerEvents';
import {
  controlSize,
  generateControlPointPath,
} from 'components/BackgroundReplacer/SourceTemplate/SimpleEditor/utils';

const ScalingControl: React.FC<ScalingControlProps> = (props) => {
  const isMobile = isTouchDevice();

  const handlePointerMove = (point: Point | null): void => {
    if (point) {
      props.onMove(point);
    }
  };

  const [onPointerDown, onPointerMove, onPointerUp] = usePointerEvents({
    center: props.center,
    setTransform: props.transform,
    moveTransform: props.transform,
    getAreaStartPoint: props.getAreaStartPoint,
    onMove: handlePointerMove,
  });

  if (isMobile) {
    return (
      <>
        <polygon
          fill={themeStyle.backgroundAlt}
          points={generateControlPointPath(props.center, {
            width: controlSize,
            height: controlSize,
          })}
          stroke={themeStyle.selectionBlue}
          strokeWidth={1}
          transform={props.transformString}
        />
        <polygon
          cursor={`${props.scaleDirection}-resize`}
          fill="transparent"
          points={generateControlPointPath(props.center, {
            width: controlSize * 4,
            height: controlSize * 4,
          })}
          transform={props.transformString}
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
        />
      </>
    );
  }

  return (
    <polygon
      cursor={`${props.scaleDirection}-resize`}
      fill={themeStyle.backgroundAlt}
      points={generateControlPointPath(props.center, {
        width: controlSize,
        height: controlSize,
      })}
      stroke={themeStyle.selectionBlue}
      strokeWidth={1}
      transform={props.transformString}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
    />
  );
};

export default withEventScope(ScalingControl, { module: 'scalingControl' });
